import React from "react";
import exit from "@images/exit.svg";

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <img src={exit} alt="exit" />
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
